import React from "react";
import "./Mobile.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import img13 from "../assets/13.png";
import img14 from "../assets/14.png";
import { FaArrowCircleDown } from "react-icons/fa";

const steps = [
    {
        title: "Create an Account",
        description: "Sign up for a trading account if you haven’t already. Registration is quick and easy. Just contact us today. Our Support agents will help you to navigate and guide you to open an account."
    },
    {
        title: "Download the Terminal",
        description: "Ask our support agent to get the latest version of the Globus Trading PC Terminal or login to client cabinet after signup and you will have option of downloading the PC terminal."
    },
    {
        title: "Log In",
        description: "Use your credentials to log into the terminal and start exploring its features. When you signup with Globus trading, you will get the login credentials for client cabinet and also your trading account will be opened and you can login with your trading account and password to your PC terminal and start trading."
    },
    {
        title: "Fund Your Account",
        description: "Deposit funds to begin trading. We offer multiple funding options for your convenience. After login to your cabinet you will have the option to deposit funds in your trading account. We provide many payment options to fund your trading account. After adding the funds you can start the trading with Globus trading."
    }
];


const features = [
    {
        title: "Intuitive User Interface",
        description: "Our app’s clean and intuitive interface ensures that even new traders can navigate the forex markets with ease. Access real-time data, charts, and trading options effortlessly, ensuring a smooth trading experience every time you log in."
    },
    {
        title: "Advanced Charting Tools",
        description: "Analyze the markets like a pro with our advanced charting tools. Customize your charts with a variety of technical indicators, drawing tools, and timeframes to suit your trading strategy. From simple line charts to complex candlestick patterns, our app supports it all."
    },
    {
        title: "Instant Trade Execution",
        description: "Experience lightning-fast trade execution with our robust trading engine. Execute orders instantly, manage your trades in real-time, and capitalize on market opportunities without delay."
    },
    {
        title: "Custom Alerts and Notifications",
        description: "Set custom alerts and receive instant notifications about market movements, price changes, and economic events. Stay informed and ready to act on market opportunities as they arise."
    },
    {
        title: "Real-Time Market Data",
        description: "Stay ahead of the curve with real-time updates on currency pairs, market trends, and economic news. Our app delivers precise data feeds, ensuring you’re always informed about the latest market movements."
    },
    {
        title: "Secure Transactions",
        description: "Trade with confidence knowing your data and funds are protected. The Globus Trading Mobile App employs state-of-the-art encryption and security protocols to safeguard your personal information and trading activities."
    },
    {
        title: "Comprehensive Account Management",
        description: "Manage your trading account with ease. Monitor your account balance, view your trade history, manage your open positions, and fund your account directly from the app."
    },
    {
        title: "24/7 Customer Support",
        description: "Our dedicated support team is available around the clock to assist you with any questions or issues you may have. Access our support via chat, email, or phone directly from the app."
    }
];

const Mobile = () => {
    return (
        <>
            <Navbar />

            {/* About Us Section */}
            <div className="pc-section">
                <h2 className="pc-title">Globus Mobile App</h2>
            </div>

            {/* Section 1: Two Columns - Image Left, Details Right */}
            <div className="pc-container">
                <div className="pc-content">
                    <div className="pc-image">
                        <img src={img13} alt="Globus PC Terminal" />
                    </div>
                    <div className="pc-details">
                        <h2>Globus Trading Mobile App:<br></br>
                            Transform Your Forex
                            Trading Experience</h2>
                        <p>
                            Globus Trading Mobile App – your gateway to seamless and dynamic forex trading, available right at your fingertips. Our app is designed to provide traders with a powerful, user-friendly platform that combines cutting-edge technology with comprehensive trading features.
                        </p>
                    </div>
                </div>
            </div>

            {/* Key Features Section */}
            <div className="features-section">
                <h2 className="features-title">What Globus Mobile Trader Offers!!</h2>
                <p>Ready to take your forex trading to the next level? Download the Globus Trading Mobile App today. Experience the <br></br>ultimate in mobile forex trading and join thousands of traders worldwide who trust Globus Trading as their partner in financial markets.</p>
                <div className="features-grid2">
                    {features.map((feature, index) => (
                        <div className="feature-box" key={index}>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="pc-container">
                <div className="pc-content">
                    <div className="pc-image2">
                        <img src={img14} alt="Globus PC Terminal" />
                    </div>
                    <div className="pc-details">
                        <h2>Easy As 1…2…3…</h2>
                        <p>
                            You can just start trading with Globus Trading app with just 3 easy steps :<br></br>
                            <br></br>
                            1. Sign up – Just register with the form that is provided. And you will get the credentilas to login.<br></br>
                            <br></br>
                            2. Download & Install App – You can download and Install App from Android playstore or iOS app store. Or you can install it from login into client cabinet as well.<br></br>
                            <br></br>
                            3. Login & Trade – Now as you have installed the app, you can login in the app. Now you can deposit the money and start trading.
                        </p>
                    </div>
                </div>
            </div>

            <div className="get-started-section">


                <div className="steps-container">
                    <div className="step-box">
                        <div className="icon">⬇️ Globus Android App</div>

                        <p>Elevate your trading experience with the Globus Trading Android App, crafted for seamless performance on Android devices. Navigate the forex markets effortlessly with real-time data, customizable charts, and swift trade execution.</p>
                    </div>

                    <div className="step-box">
                        <div className="icon">⬇️ Globus iOS App</div>

                        <p>Unleash the power of forex trading with the Globus Trading iOS App, optimized for iPhone and iPad. Experience a sleek, intuitive interface that brings real-time market insights, advanced charting tools, and immediate trade execution to your device.</p>
                    </div>


                </div>


            </div>



            <Footer />
        </>
    );
};

export default Mobile;
